import { Stack, Tabs } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'
import useIsSuperAdmin from '../../hooks/useIsSuperAdmin'
import {
  ProfileHeader,
  ProfileTabNavigation,
  ProfileTabContent,
} from './components'
import { useProfileNavigation, useProfileData } from './hooks'

interface ProfilePageProps {
  uid: string
  canEditLockedMedicalDates?: boolean
}

const ProfilePage = ({
  uid,
  canEditLockedMedicalDates = false,
}: ProfilePageProps) => {
  const { user } = useProfileData(uid)
  const { currentHash, currentIndex, handleTabChange, handleHashChange } =
    useProfileNavigation()

  if (!uid) return null

  return (
    <Stack spacing={2}>
      <ProfileHeader user={user} />
      <Tabs
        variant='enclosed-colored'
        colorScheme='purple'
        onChange={handleTabChange}
        index={currentIndex}
      >
        <ProfileTabNavigation
          currentHash={currentHash}
          onHashChange={handleHashChange}
        />
        <ProfileTabContent
          uid={uid}
          user={user}
          canEditLockedMedicalDates={canEditLockedMedicalDates}
        />
      </Tabs>
    </Stack>
  )
}

const ProfilePageContainer = () => {
  const { uid } = useProfileData()

  return uid ? <ProfilePage uid={uid} /> : null
}

export const AdminEditProfile = () => {
  const { id } = useParams<{ id: string }>()
  const isSuperAdmin = useIsSuperAdmin()

  return id ? (
    <ProfilePage uid={id} canEditLockedMedicalDates={isSuperAdmin} />
  ) : null
}

export default ProfilePageContainer
